import React, { useContext, useEffect, useState } from "react"; //FB 7459
import Button from "@material-ui/core/Button";
import { Grid, Typography } from "@material-ui/core";
import {
  AppointmentObject,
  ApptContext,
  InitialApptObj,
  InitialSlotsObj,
} from "../../../../../store";
import useStyles from "../../../../../css/styles_PE";
import { AccountCircle, Business, CalendarToday } from "@mui/icons-material";
import ProviderComponent from "./Components/Provider";
import LocationComponent from "./Components/Location";
import DateComponent from "./Components/Date";
import DateComponent_Tele from "./Components/Date_Telederm";
import { InsertPPLogs, GetAdminSettingValue, GetAppointmentTypeFromAdmin } from "../../../../../api"; //FB 7459  //FB 8024
import { GetFacilities, GetProviders } from "../../../../../api/PE_API";  //FB 8796 //FB 8722

// Update log
// FB  6192   02/06/2023  DK  Page to determine the type of appointment filtration
// FB  7413   09/25/2023  GA  Orady - Update the map link to the correct one
// FB  7459   09/25/2023  GA  Orady - By Locations should be disabled in the Patient portal while booking an appointment
// FB  8024   01/03/2023  SK  Including Recent Patient Engagement Enhancements to Patient Portal
// FB  8214   02/01/2024  SK  Accept Case Sensitive Admin Setting Value for Enable PE Custom Appointments in API and Portal and PE
// FB  8796   06/23/2024  KI  Removing provider option if we have only one provider
// FB  8549   10/21/2024  DK  TeleHealth re-work
// FB  8722   11/06/2024  DK  PE workflows enhancements


export default function AppointmentFilterPage(props: any) {
  const classes = useStyles();
  const { state, dispatch } = useContext(ApptContext);
  const [apptFilter, setApptFilter] = useState(state.AppointmentFilter);
  const handleClick = (selectedFilter: string) => {
    setApptFilter(selectedFilter);
    state.AppointmentType = state.AppointmentType;
    state.AppointmentFilter = selectedFilter;
    state.Provider = {
      ID: 0,
      Name: "",
      Facility_n: 0,
      Bio: "",
      JobTitle: ""
    };
    state.Facility = {
      ID: 0,
      Name: "",
      Address: "",
      Phone: "",
      Region: 0,
      GOOGLE_MAPS_LINK: "" // FB 7413
    };
    state.FacilityRegion = {
      ID: 0,
      Name: "",
      State: ""
    }
    state.AppointmentDate = new Date();
    state.Duration = 0;
    state.SlotDetails = InitialSlotsObj;
    state.Appointment_N = 0;

    if (selectedFilter == "location") {
      InsertPPLogs(
        "Selected by office location",
        window.location.href,
        userName,
        ""
      );
    } else if (selectedFilter == "date") {
      InsertPPLogs("Selected by date", window.location.href, userName, "");
    } else if (selectedFilter == "provider") {
      InsertPPLogs("Selected by provider", window.location.href, userName, "");
    }
  };
  let patientName = "User";
  let userName: any;
  let data = sessionStorage.getItem("user");
  if (data != null) {
    patientName = JSON.parse(data).PatientFirstName;
    userName = JSON.parse(data).Login;
  }

  const handleGoback = () => {
    //FB 8024 - Begin
    if (enableCustomAppointment == "true") {
      props.setCustomAppointmentType("");
    }
    else {
      props.setApptType("");
    }
    //FB 8024 - End
    InsertPPLogs(
      "Clicked on Go Back - Appointment Filter",
      window.location.href,
      userName,
      ""
    );
  };
  const [isSingleLocation, setIsSingleLocation] = useState(false);  //FB 8722

  function getcomponent() {
    switch (apptFilter) {
      case "provider":
        return <ProviderComponent setApptFilter={setApptFilter} />;
        break;

      case "location":
        return <LocationComponent setApptFilter={setApptFilter} />;
        break;

      case "date":
        return state.AppointmentType === "telederm" ? (
          <DateComponent_Tele setApptFilter={setApptFilter} />
        ) : (
          <DateComponent setApptFilter={setApptFilter} />
        );
        break;

      default:
        break;
    }
  }

  const scrollTo = (ref: any) => {
    if (ref) {
      ref.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  //FB 7459 Begin
  const [enableByOfficeLocationFilter, setByOfficeLocation] = useState(false);
  const [enableCustomAppointment, setEnableCustomAppointment] = useState("");//FB 8024
  const [enableByProviderFilter, setByProvider] = useState(false); //FB 8796

  async function enableByOfficeLocation() {
    let setting = await GetAdminSettingValue("Portal_Enable_By_Office_location");
    if (Number(setting) === 1) {
      setByOfficeLocation(true);
    }
    else {
      setByOfficeLocation(false);
    }
    //FB 8024 - Begin
    const customApptAdmin = (await GetAdminSettingValue("Enable PE Custom Appointments"))[0].toLowerCase();//FB 8214
    setEnableCustomAppointment(customApptAdmin);
    //FB 8214
    if (customApptAdmin == "false") {
      var apptTypes: any = "";
      if (state.AppointmentType == "inoffice") {
        apptTypes = await GetAppointmentTypeFromAdmin("Existing Patient - Inoffice Appointment").then(function (apptTypes) {
          sessionStorage.setItem("AppointmentType_N", apptTypes[0].Id); //FB 8549
          sessionStorage.setItem("AppointmentType", "Existing Patient - Inoffice Appointment");
          sessionStorage.setItem("Duration", apptTypes[0].DURATION);
        })
      }
      else if (state.AppointmentType == "telederm") {
        apptTypes = await GetAppointmentTypeFromAdmin("Existing Patient - TeleHealth Appointment").then(function (apptTypes) {
          sessionStorage.setItem("AppointmentType_N", apptTypes[0].Id); //FB 8549
          sessionStorage.setItem("AppointmentType", "Existing Patient - TeleHealth Appointment");
          sessionStorage.setItem("Duration", apptTypes[0].DURATION);
        })
      }
    }
    //FB 8024 - End
  }

  //FB 8796 start
  useEffect(() => {
    const fetchProviders = async () => {
      enableByOfficeLocation();
      try {
        const data = await GetProviders(0, state.AppointmentType);
        if (data.length > 1) {
          setByProvider(true);
        }
      } catch (error) {
        console.error("Error fetching providers:", error);
        setByProvider(false);
      }
    };

    //FB 8722
    const fetchLocations = async () => {
      const data = await GetFacilities(0);
      if (data.length == 1) {
        setIsSingleLocation(true);
      }
    }

    fetchProviders();
    fetchLocations(); //FB 8722
  }, []);
  //FB 8796 end
  //FB 7459 End
  return (
    <div ref={scrollTo}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography id="chooseMessage" variant="h6">
            Choose how to create an appointment
          </Typography>
        </Grid>
        <Grid
          item
          xs={6}
          md={4}
          lg={3}
          style={{
            display:
              state.AppointmentType === "telederm" ||
                apptFilter === "provider" ||
                apptFilter === "date"
                ? "none"
                : (enableByOfficeLocationFilter && !isSingleLocation ? "inline-flex" : "none"), //FB 7459 //FB 8722
          }}
        >
          <Button
            variant="outlined"
            onClick={() => handleClick("location")}
            startIcon={<Business />}
            className={
              apptFilter === "location"
                ? classes.buttonActive
                : classes.buttonInactive
            }
          >
            By Office Location
          </Button>
        </Grid>
        <Grid
          item
          xs={6}
          md={3}
          lg={2}
          style={{
            display:
              apptFilter === "location" || apptFilter === "provider"
                ? "none"
                : "inline-flex",
          }}
        >
          <Button
            variant="outlined"
            id="byDate"
            onClick={() => handleClick("date")}
            startIcon={<CalendarToday />}
            className={
              apptFilter === "date"
                ? classes.buttonActive
                : classes.buttonInactive
            }
          >
            By Date
          </Button>
        </Grid>
        <Grid
          item
          xs={6}
          md={3}
          lg={2}
          style={{
            display:
              apptFilter === "location" || apptFilter === "date"
                ? "none"
                //FB 8796
                : (enableByProviderFilter ? "inline-flex" : "none"),
          }}
        >
          <Button
            variant="outlined"
            id="byProvider"
            onClick={() => handleClick("provider")}
            startIcon={<AccountCircle />}
            className={
              apptFilter === "provider"
                ? classes.buttonActive
                : classes.buttonInactive
            }
          >
            By Provider
          </Button>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        className={classes.flexend_Grid}
        style={{
          display: apptFilter === "" ? "inline-flex" : "none",
        }}
      >
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={3}
          className={classes.flexend_Grid}
          style={{ marginTop: 10 }}
        >
          <Button
            onClick={handleGoback}
            id="gobackByDate"
            variant="contained"
            className={classes.navigationButton}
          >
            Go Back
          </Button>
        </Grid>
      </Grid>
      <React.Fragment>{getcomponent()}</React.Fragment>
    </div>
  );
}
